import { useEffect, useRef, useState } from 'react'

/** Precisa acompanhar a animação `searchShrink` do CSS. */
const COLLAPSE_DURATION = 160

/**
 * Campo que expande no clique e recolhe com animação, focando o input ao
 * abrir. Fica expandido enquanto `hasContent` for verdadeiro.
 */
export const useCollapsibleField = (hasContent: boolean) => {
  const fieldRef = useRef<HTMLDivElement>(null)
  const collapseTimer = useRef<ReturnType<typeof setTimeout>>()

  const [isOpen, setIsOpen] = useState(hasContent)
  /** Mantém o campo montado durante a animação de recolher. */
  const [isClosing, setIsClosing] = useState(false)

  const isExpanded = isOpen || hasContent

  useEffect(() => {
    if (!isExpanded) return

    setIsClosing(false)

    const frame = requestAnimationFrame(() =>
      fieldRef.current?.querySelector('input')?.focus()
    )

    return () => cancelAnimationFrame(frame)
  }, [isExpanded])

  // nada pode disparar setState depois do unmount
  useEffect(() => () => globalThis.clearTimeout(collapseTimer.current), [])

  const collapse = () => {
    setIsClosing(true)
    collapseTimer.current = globalThis.setTimeout(() => {
      setIsClosing(false)
      setIsOpen(false)
    }, COLLAPSE_DURATION)
  }

  return {
    fieldRef,
    isClosing,
    isExpanded,
    collapse,
    open: () => setIsOpen(true)
  }
}
